module.exports = __webpack_public_path__ + "1bd8ed9b11f33e94d7f0827f16e2b185.svg";